import 'rsuite/dist/rsuite.min.css';
import './Tabs.css';
import React, { useState } from 'react';
import { Nav } from 'rsuite';

export function useTabs (schema) {
    const [localSchema, setLocalSchema] = useState(schema);
    const [selected, setSelected] = useState(localSchema[0]);

    function setPopover (name, value) {
        setLocalSchema(localSchema.map(tab => {
            if (tab.name !== name) return tab;
            tab.popover = value;
            return tab;
        }));
    }

    return {
        schema: localSchema,
        selected,
        setSelected,
        setPopover,
    };
}

export default function Tabs ({ className, schema, selected, onSelect }) {
    return (
        <Nav
            className={className}
            activeKey={selected}
            onSelect={onSelect}
        >
            {schema.map(item => (
                <Nav.Item
                    className='tab-item'
                    id={item.id}
                    key={item.id}
                    eventKey={item}
                    active={item.id === selected.id}
                >
                    <span className='tab-item-popover' open={!!item.popover}>{item.popover}</span>
                    <b>{item.label}</b>
                </Nav.Item>
            ))}
        </Nav>
    );
}
